import { ref, provide, inject } from 'vue'

const LANGUAGE_KEY = 'currentLanguage'
const LANGUAGE_TOGGLE_KEY = 'toggleLanguage'

export function provideLanguage() {
  const currentLanguage = ref('en')

  const toggleLanguage = () => {
    currentLanguage.value = currentLanguage.value === 'en' ? 'el' : 'en'
  }

  provide(LANGUAGE_KEY, currentLanguage)
  provide(LANGUAGE_TOGGLE_KEY, toggleLanguage)

  return {
    currentLanguage,
    toggleLanguage
  }
}

export function useLanguage() {
  const currentLanguage = inject(LANGUAGE_KEY)
  const toggleLanguage = inject(LANGUAGE_TOGGLE_KEY)

  if (!currentLanguage || !toggleLanguage) {
    throw new Error('Language context not found. Make sure to call provideLanguage in a parent component.')
  }

  return {
    currentLanguage,
    toggleLanguage
  }
}
